import React from 'react'
import {LobbyImage} from '@colonist/types'
/* eslint-disable no-restricted-imports */
import {getLobbyImagePath} from '../../../../../../code/client/shared/scripts/ui_utils/Utils'
import styles from './UIGameHelpFullScreenButton.module.scss'
import clsx from 'clsx'
import {useUIGameFullScreenContext} from './UIGameHelpFullScreenContext'

export interface UIGameHelpFullScreenButtonProps {
    className?: string
}

export const UIGameHelpFullScreenButton = ({
    className,
}: UIGameHelpFullScreenButtonProps) => {
    const {isFullScreen, toggleFullScreen} = useUIGameFullScreenContext()

    return (
        <div>
            <img
                className={clsx(styles.fullScreenButton, className)}
                onClick={toggleFullScreen}
                src={getLobbyImagePath(isFullScreen ? LobbyImage.FullScreenContract : LobbyImage.FullScreenExpand)}/>
        </div>
    )
}
